var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"homePage"},[_c('HomeIntro'),_c('HomeAbout'),_c('NewSlider'),_c('HomePress'),_c('HomeRegions'),_c('Contact'),_c('div',{staticClass:"whiteLayer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }